import { useMemo } from 'react';
import { LazadaStandaloneAuthResultBody } from 'services/api/admin';
import ErrorResult from './ErrorResult';
import SuccessResult, { SuccessResultProps } from './SuccessResult';
import ScopeWarningResult from './ScopeWarningResult';

export interface AuthResultProps extends SuccessResultProps {
  result: LazadaStandaloneAuthResultBody;
  onNeedHelp: () => void;
}

const AuthResult = (props: AuthResultProps) => {
  const { result, onFinish, onRestart, onNeedHelp, isConfigService, onConfigService } = props;
  const comp = useMemo(() => {
    if (result.isSuccess) {
      // 部分店铺不在当前套餐的可授权站点范围内时，整页替换为裁剪结果
      if (result.authorizationScope && result.authorizationScope.excludedStores.length > 0) {
        return (
          <ScopeWarningResult
            scope={result.authorizationScope}
            authorizedCount={result.successCount ?? 0}
            onFinish={onFinish}
          />
        );
      }
      return (
        <SuccessResult
          onFinish={onFinish}
          onRestart={onRestart}
          count={result.successCount}
          isConfigService={isConfigService}
          onConfigService={onConfigService}
        />
      );
    }
    return <ErrorResult error={result.errorMsg} onRestart={onRestart} onNeedHelp={onNeedHelp} />;
  }, [
    isConfigService,
    onConfigService,
    onFinish,
    onNeedHelp,
    onRestart,
    result.authorizationScope,
    result.errorMsg,
    result.isSuccess,
    result.successCount,
  ]);
  return comp;
};
export default AuthResult;
